import React from 'react';
import { useParams, Navigate } from 'react-router';
import { CrudPage } from '@/components/shared/crud-page';
import {
  PEOPLE_CONFIGS, FLEET_EXTRAS_CONFIGS, DISPATCH_EXTRAS_CONFIGS,
  SERVICING_EXTRAS_CONFIGS, OPERATIONS_CONFIGS, INTEGRATION_CONFIGS,
  COMPLIANCE_CONFIGS, AUDIT_CONFIGS,
} from './configs';

function makePage(configs: Record<string, any>) {
  return function Page() {
    const { entity } = useParams<{ entity: string }>();
    if (!entity || !configs[entity]) return <Navigate to="/dashboard" replace />;
    return <CrudPage config={configs[entity]} />;
  };
}

export const PeoplePage = makePage(PEOPLE_CONFIGS);
export const FleetExtrasPage = makePage(FLEET_EXTRAS_CONFIGS);
export const DispatchExtrasPage = makePage(DISPATCH_EXTRAS_CONFIGS);
export const ServicingExtrasPage = makePage(SERVICING_EXTRAS_CONFIGS);
export const OperationsPage = makePage(OPERATIONS_CONFIGS);
export const IntegrationPage = makePage(INTEGRATION_CONFIGS);
export const CompliancePage = makePage(COMPLIANCE_CONFIGS);
export const AuditPage = makePage(AUDIT_CONFIGS);
